<template>
	<div class="prices">
		<b-card-group deck>
			<b-card header-tag="header" footer-tag="footer">
				<div slot="header" class="top-card">
					<span>
						<h5>{{$t('pricing.addTitle')}}</h5>
					</span>
					<div style="align-items: center;display: flex;">
						<b-link @click="toggleForm.form = !toggleForm.form" class="card-header-action btn-setting"
								style="font-size: 15px">
							<i class="fa fa-search"></i>
						</b-link>
						<b-button variant="outline" @click.prevent="closeSidebar">
							<i class="fa fa-close"></i>
						</b-button>

					</div>
				</div>

				<b-form>
					<div class="top-form">
						<b-collapse v-model="toggleForm.form" id="filterColumns">
							<b-container fluid>
								<b-row class="my-1">
									<b-col sm="4">
										<label for="input-small">
											<span class="redStar">*</span>
											{{$t('pricing.registrationNo')}}
										</label>
										<b-input-group
											size="sm"
											class="mb-3"
										>
											<b-form-input :placeholder="$t('pricing.registrationNo')" :state="isValid"
														  v-model="regnumber"></b-form-input>
											<b-input-group-append>
												<b-button size="sm" text="Button" variant="success"
														  ref="generateRegNumberRefs"
														  @click.prevent="generateRegNumber"
														  :disabled="disabledComputed">
													<i class="fa fa-refresh"></i>
												</b-button>
											</b-input-group-append>
										</b-input-group>
									</b-col>


									<b-col sm="4">
										<label for="input-small">
											{{$t('pricing.costDate')}}
											<span class="isErrorDepartment" v-if="isInvalidDate">
											{{$t('pricing.errorDate')}}
										</span>
										</label>
										<masked-input v-model="currentDate"
													  mask="11-11-1111"
													  class="ml-1 form-control form-control-sm"
													  :placeholder="$t('pricing.costDate')"/>
									</b-col>
									<b-col sm="4">
										<label for="input-small">
											<span class="redStar">*</span>
											{{$t('pricing.department')}}
											<span class="isErrorDepartment" v-if="isInvalid">
											{{$t('pricing.errorDepartment')}}
										</span>
										</label>
										<multiselect
											:options="getDepartmentsLocal()"
											:multiple="true"
											:value="selectedDepartment"
											track-by="id"
											label="name"
											@select="handleNewDepartment"
											@remove="removeDepartment"
											:show-labels="false"
											:allow-empty="true"
											class="multiselect-pricing"
											:class="isInvalid ? 'isErrorDepartmentBorder' : ''"
										>
											<template slot="option" slot-scope="option">
												{{ option.option.name
												}} ({{ option.option.currencyCode ? option.option.currencyCode : 'no currency'
												}})
											</template>
										</multiselect>
									</b-col>
								</b-row>

								<b-row class="my-1">
									<b-col :cols="companyType === 'SHOP' ? 3 : 2" v-if="companyType !== 'SHOP'">
										<label for="input-small">
											<!--<span class="redStar">*</span>-->
											Тип
										</label>
										<b-form-select
											v-model="filter.category"
											:options="allCategory"
											value-field="id"
											text-field="name"
											@change="categorySelected"
										>
											<template slot="first">
												<option value="all">-- {{ $t('Тип') }} --</option>
											</template>
										</b-form-select>
									</b-col>
									<b-col :cols="companyType === 'SHOP' ? 3 : 2">
										<label for="input-small">
											<!--<span class="redStar">*</span>-->
											{{$t('incomes.block-counteragent.group')}}
										</label>
										<b-form-select
											v-model="subcategory.value"
											@change="subCategorySelected"
											:disabled="subcategory.isDisabled"
										>
											<option v-for="(selectOption, indexOpt) in subcategory.items"
													:key="indexOpt"
													:value="selectOption.id"
											>
												{{ selectOption.name }}
											</option>
											<template slot="first">
												<option :value="null">
													-- {{ companyType === 'SHOP' ? $t('incomes.block-counteragent.group') : 'Все Подкатегории'}} --
												</option>
											</template>
										</b-form-select>

									</b-col>
									<b-col :cols="companyType === 'SHOP' ? 3 : 2">
										<label>{{$t('incomes.block-counteragent.category')}}</label>
										<b-form-select

											v-model="subsubcategory.value"
											@change="subSubCategorySelected"
											:disabled="subsubcategory.isDisabled"

										>
											<option v-for="(selectOption, indexOpt) in subsubcategory.items"
													:key="indexOpt"
													:value="selectOption.id"
											>
												{{ selectOption.name }}
											</option>
											<template slot="first">
												<option :value="null">
													-- {{ companyType === 'SHOP' ? $t('incomes.block-counteragent.category') : 'Все Подкатегории'}} --
												</option>
											</template>
										</b-form-select>

									</b-col>
									<b-col :cols="companyType === 'SHOP' ? 3 : 2">
										<label>{{$t('prices.item.sub-category')}}</label>
										<b-form-select
											v-model="sub3category.value"
											:disabled="sub3category.isDisabled"

										>
											<option v-for="(selectOption, indexOpt) in sub3category.items"
													:key="indexOpt"
													:value="selectOption.id"
											>
												{{ selectOption.name }}
											</option>
											<template slot="first">
												<option :value="null">
													-- {{ companyType === 'SHOP' ? $t('prices.item.sub-category') : 'Все Подкатегории'}} --
												</option>
											</template>
										</b-form-select>
									</b-col>
									<b-col :cols="companyType === 'SHOP' ? 3 : 2">
										<label>{{$t('goods.artikul')}}</label>
										<b-form-input id="artikul"
													  v-model="filter.artikul"
													  name="name"
													  :placeholder="$t('goods.artikul')"
													  @focusout="setFilterToComponent"

										>
										</b-form-input>
									</b-col>
								</b-row>
								<b-row class="my-4">
									<b-col cols="3">
										<!--										<label>Doc Id/Number</label>-->
										<b-form-input id="docId"
													  v-model="filter.docIdAndDocName"
													  name="name"
													  :placeholder="$t('prices.filter.docPlaceholder')"
													  @focusout="setFilterToComponent"

										>
										</b-form-input>
									</b-col>
									<b-col cols="3">
										<!--<label>Наименования</label>-->
										<b-form-input id="name"
													  v-model="filter.name"
													  name="name"
													  :placeholder="$t('prices.item.name')"
													  @focusout="setFilterToComponent"

										>
										</b-form-input>
									</b-col>
									<b-col cols="3">
										<!--<label>Штрихкод</label>-->
										<b-form-input id="barcode"
													  v-model="filter.barCode"
													  name="barcode"
													  :placeholder="$t('goods.barcode')"
													  @focusout="setFilterToComponent"
										>
										</b-form-input>
									</b-col>
									<b-col sm="3">
										<!--<label for="input-small">-->
										<!--&lt;!&ndash;{{$t('contragent.filter')}}&ndash;&gt;-->
										<!--</label>-->
										<!--<div class="searchInCard">-->
										<b-input-group size="sm">
											<b-form-input v-model="tableFilter" size="sm"
														  :placeholder="$t('contragent.filter')"/>
											<b-input-group-append>
												<b-button :disabled="!filter" @click="filter = ''">
													{{$t('contragent.clear')}}
												</b-button>
											</b-input-group-append>
										</b-input-group>
										<!--</div>-->
									</b-col>
								</b-row>
								<div class="row my-1 justify-content-end">
									<!--<div class="col-3">
										<b-button @click="toggleSearch.filter = !toggleSearch.filter"
												  variant="btn btn-info" block size="sm">
											<i class="fa fa-money" style="color: white" aria-hidden="true"></i> &nbsp;
											<span style="color:white;">{{$t('prices.item.priced-products')}} </span>
											<i style="color: white;" class="fa fa-arrow-down" aria-hidden="true"></i>

										</b-button>
									</div>-->
									<div class="col-7"></div>
									<!--<div class="col-2">
										<b-button @click="saveREADY('SUSPENDED')" variant="btn btn-warning" block
												  size="sm">
											<i class="fa fa-save"></i> &nbsp;
											<span>{{$t('actions.save')}}</span>
										</b-button>
									</div>-->
									<div class="col-3">
										<b-button @click="saveREADY('READY')" variant="btn btn-success" block size="sm">
											<i class="fa fa-save"></i> &nbsp;
											<span>{{$t('save-finish')}}</span>
										</b-button>
									</div>
									<div class="col-2">
										<!--<label >{{$t('contragent.filter')}}</label>-->
										<b-button variant="btn btn-primary" size="sm" block @click="searchPricing">
											<i class="fa fa-search" aria-hidden="true"></i> {{$t('contragent.filter')}}
										</b-button>
									</div>
								</div>
								<b-collapse v-model="toggleSearch.filter" id="filterColumns">
									<b-table
										:items="getPricedItems" :fields="computedFieldsFilter"
										style="max-width: 800px ;white-space: nowrap">
										<template slot="details" slot-scope="data">
											{{data.item.name ? data.item.name.substring(0, 20) : ''
											}} / <strong>{{ data.item.artikul }}</strong> / {{ data.item.colorName
											}} / {{ data.item.size }} /
											<strong>{{ data.item.barcode }}</strong>
										</template>
										<template slot="incomeUzs" slot-scope="data">
											{{data.item.incomeUzs | currency({
											symbol: depCurrencyName, fractionCount: 2, symbolPosition: 'back',
											thousandsSeparator: ' '
											})}}
										</template>
										<template slot="priceUzs" slot-scope="data">
											{{data.item.priceUzs | currency({
											symbol: depCurrencyName, fractionCount: 2, symbolPosition: 'back',
											thousandsSeparator: ' '
											})}}
										</template>

									</b-table>
								</b-collapse>
							</b-container>
						</b-collapse>
					</div>
					<div>
						<b-alert variant="danger" :show="emptyErrorTable">
							<span class="emptyErrorTable">Пожалуйста, введите цену на товары!</span>
						</b-alert>
					</div>
					<div class="table-responsive table-wrapper">
						<b-table class="generalTableClass" :hover="hover" :striped="striped" :bordered="bordered"
								 :small="small"
								 :fixed="fixed"
								 :filter="tableFilter"
								 :items="items"
								 responsive="sm" :fields="computedFields">

							<template slot="id" slot-scope="data">
								<strong>{{ data.index + 1 }}</strong>
							</template>

							<template slot="details" slot-scope="data">
								{{ data.item.name }} / <strong>{{ data.item.colorName }} /
								{{ data.item.size }}</strong>
							</template>

							<template slot="barcode" slot-scope="data">
								{{ data.item.barcode }}
							</template>

							<template slot="artikul" slot-scope="data">
								{{ data.item.artikul }}
							</template>

							<template slot="incomeUzs" slot-scope="data">
								<!--<b-form-input :ref="data.index + '1'" type="text" v-if="ok"
											  onClick="this.setSelectionRange(0, this.value.length)"
											  @keyup.up.left.right.down="focusInput($event ,data.index, 1)"
											  v-model="data.item.incomeUzs" v-focus class="move">
								</b-form-input>
								<div v-else data-toggle="tooltip" :title="$t('pricing.update')"
									 @click="OkFunction(data.index + '1')">
									<div v-if="data.item.incomeUzs > 0"> {{data.item.incomeUzs |
										currency({
										symbol: depCurrencyName, symbolPosition: 'back',
										thousandsSeparator: ' '
										})}}
									</div>
									<div v-else></div>
								</div>-->
								<span v-if="data.item.incomeUzs > 0">
									{{data.item.incomeUzs | currency({
								symbol: depCurrencyName, fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
								})}}
								</span>
								<span v-else> </span>
							</template>
							<template slot="newIncomeUzs" slot-scope="data">
								<b-form-input :ref="data.index + '1'" type="text" v-if="ok"
											  onClick="this.setSelectionRange(0, this.value.length)"
											  @keyup.up.left.right.down="focusInput($event ,data.index, 1)"
											  v-model="data.item.newIncomeUzs" v-focus class="move">
								</b-form-input>
								<div v-else data-toggle="tooltip" :title="$t('pricing.update')"
									 @click="OkFunction(data.index + '1')">
									<div v-if="data.item.newPriceUzs > 0"> {{data.item.newIncomeUzs |
										currency({
										symbol: depCurrencyName,fractionCount: 2, symbolPosition: 'back',
										thousandsSeparator: ' '
										})}}
									</div>
									<div v-else class="emptyDivForPricing"></div>
								</div>
							</template>
							<!--<template slot="uzb" slot-scope="data">
								<span v-if="data.item.priceUzs > 0">
									{{data.item.priceUzs | currency({
								symbol: depCurrencyName, fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
								})}}
								</span>
								<span v-else> </span>
							</template>
							<template slot="newPriceWholesale" slot-scope="data">
								<b-form-input :ref="data.index + '2'" type="text" v-if="ok"
											  onClick="this.setSelectionRange(0, this.value.length)"
											  @keyup.up.left.right.down="focusInput($event ,data.index, 2)"
											  v-model="data.item.newPriceWholesale" v-focus class="move">
								</b-form-input>
								<div v-else data-toggle="tooltip" :title="$t('pricing.update')"
									 @click="OkFunction(data.index + '2')">
									<div v-if="data.item.newPriceWholesale > 0"> {{data.item.newPriceWholesale |
										currency({
										symbol: depCurrencyName, fractionCount: 2, symbolPosition: 'back',
										thousandsSeparator: ' '
										})}}
									</div>
									<div v-else class="emptyDivForPricing"></div>
								</div>
							</template>
							<template slot="lastPriceWholesale" slot-scope="data">
								<span v-if="data.item.priceWholesale > 0">
									{{data.item.priceWholesale | currency({
								symbol: depCurrencyName, fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
								})}}
								</span>
								<span v-else> </span>
							</template>-->
						</b-table>
						<div v-if="loader" class="spinner-wrapper">
							<b-spinner variant="primary"></b-spinner>
						</div>
						<div class="col-4 pl-0">
							<b-form-textarea
								style="height: 50px;"
								id="textarea"
								v-model="comment"
								:placeholder="$t('promo-to-product.comment')"
								rows="3"
								max-rows="6"
							></b-form-textarea>
						</div>
					</div>


				</b-form>

			</b-card>
		</b-card-group>
	</div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import MaskedInput from 'vue-masked-input'
import Multiselect from 'vue-multiselect'
import ReferencesService from "../../../services/references.sevice";
import PriceFilter from "../../point-of-sale/PriceFilter";
import {TokenService} from "../../../services/storage.service";


export default {
		name:"addPricing",
		directives: {
			focus: {
				inserted: function (el) {
					el.focus()
				}
			}
		},
		watch: {
			getEditItems: {
				handler(newVal) {
					if (this.getEditItems && this.isSidebarOpen) {

						this.currentDate = this.getEditItems.costDate;
						this.filter.id = this.getEditItems.id;
						this.regnumber = this.getEditItems.costNumber;
						this.getEditItems.companies.forEach(item => {
							// this.selectedDepartment.push(item)
							this.selectedDepartment.push(item);
						});
						this.items = this.getEditItems.pricingItems;
						if (this.getEditItems) {
							if (this.getEditItems.pricingItems.length > 0) {
								this.getPricedItems.push(...this.getEditItems.pricingItems);
							}
						}
						this.subcategory.isDisabled = false;
					}


					// this.setCompanyType();

				}
			},
			'isSidebarOpen': {
				handler(newValue) {
					if (newValue) {
						var today = new Date();
						var dd = String(today.getDate()).padStart(2, '0');
						var mm = String(today.getMonth() + 1).padStart(2, '0');
						var yyyy = today.getFullYear();
						this.currentDate = dd + '-' + mm + '-' + yyyy;
					}
				}
			},
			'count': {
				handler(newValue) {
					if (newValue > 1) {
						this.filterPricing();
					}
				}
			},
			'getRegNumber': {
				handler(newValue) {
					this.regnumber = newValue;
				}
			},

			watch: {
				'filter.departmentId': {
					deep: true,
					handler(newVal) {
						if (Object.keys(this.filter.departmentId).length !== 0) {
							this.setCompanyType()
							if (this.companyType === 'SHOP') {
								this.subcategory.isDisabled = false
							}
							this.disabled = false

						} else {
							this.disabled = true
							if (this.companyType !== 'SHOP') {
								this.filter.category = 'all'
								this.categoryCode = null;
							}
							this.subcategory.value = null;
							this.subsubcategory.value = null;
							this.sub3category.value = null

							this.sub3category.isDisabled = true
							this.subcategory.isDisabled = true
							this.subsubcategory.isDisabled = true
						}
					}
				},
				'filter.category': {
					handler() {
						this.subcategory.value = null
						this.subsubcategory.value = null
						this.sub3category.value = null
					}
				},

			},
		},
		data() {
			return {
				clearTable: '',
				pricingStatus: '',
				count: 0,
				loader: false,
				toggleSearch: {
					filter: false
				},
				toggleForm: {
					form: true
				},
				getPricedItems: [],
				filter: {
					id: null,
					departmentId: [],
					start: '',
					end: '',
					depsId: [],
					barCode: null,
					name: null,
					category: 'all',
					artikul: '',
					docIdAndDocName: '',
				},
				tableFilter: '',
				currency: this.userDepCurrencyCode,
				depCurrencyName: this.userDepCurrencyName,
				emptyErrorTable: false,
				newItem: [],
				items: [],
				currentDate: '',
				selectedDepartment: [],
				isValid: '',
				ok: false,
				regnumber: '',
				comment: '',
				activeSidebar: false,
				isErrorDepartment: false,
				validDate: true,
				search: '',
				allCategory: [],
				companyType: '',
				categoryCode: null,
				subcategory: {
					items: [],
					value: null,
					isDisabled: true,
				},
				subsubcategory: {
					items: [],
					value: null,
					isDisabled: true,

				},
				sub3category: {
					items: [],
					value: null,
					isDisabled: true,
				},
				disabled: true,
				attr: {}

			}
		},
		props: {

			isSidebarOpen: {
				type: Boolean,
				default: false
			},
			caption: {
				type: String,
				default: 'Users'
			},
			hover: {
				type: Boolean,
				default: true
			},
			striped: {
				type: Boolean,
				default: true
			},
			bordered: {
				type: Boolean,
				default: false
			},
			small: {
				type: Boolean,
				default: false
			},
			fixed: {
				type: Boolean,
				default: false
			}
		},

		computed: {
			computedFields() {
				return [
					{
						key: 'id',
						label: '№',
					},
					{
						key: 'docId',
						'class': 'role_id',
						label: this.$t('prices.item.docId')
					},
					{
						key: 'docDate',
						label: this.$t('prices.item.docDate')
					},
					{
						key: 'docNumber',
						label: this.$t('prices.item.docNumber')
					},
					{
						key: 'details',
						label: this.$t('prices.item.details'),
						'class': 'width26percent',
					},
					{
						key: 'barcode',
						label: this.$t('goods.barcode'),

					},
					{
						key: 'artikul',
						label: this.$t('goods.artikul'),

					},
//						{
//							key: 'brandName',
//							label: this.$t('prices.item.manufacturer')
//						},
					{
						key: 'incomeUzs',
						label: this.$t('prices.item.sum'),
						'class': 'width6Percent',
					},
					{
						key: 'newIncomeUzs',
						label: this.$t('prices.item.newIncomeUzs'),
					},
					/*{
						key: 'uzb',
						label: this.$t('prices.item.lastPriceUzs'),
						'class': 'width6Percent',
					},
					{
						key: 'newPriceWholesale',
						label: this.$t('prices.item.newPriceWholesale'),
					},
					{
						key: 'lastPriceWholesale',
						label: this.$t('prices.item.lastPriceWholesale'),
						'class': 'width6Percent',
					}*/
				]
			},
			/* THIS IS FOR SMALL TABLE UNDER THE FILTER */
			computedFieldsFilter() {
				return [
					{
						key: 'itemId',
						label: '№',
						'class': 'min-10',
					},
					{
						key: 'details',
						label: this.$t('prices.item.details'),
					},
					{
						key: 'incomeUzs',
						label:  this.$t('prices.item.sum'),
						'class': 'textAlignCenter',
					}
				]
			},
			clearPricingFilter() {
				this.clearTable = '';
			},
			disabledComputed() {
				if (this.regnumber.length === 0) {
					return false;
				} else {
					return true
				}
			},
			listWarehouse() {
				return this.departments.filter(item => {
					return item.typeName === 'COMPANY' || item.typeName === 'SHOP';
				})
			},
			isInvalid() {
				return this.isErrorDepartment && this.selectedDepartment.length === 0
			},
			isInvalidDate() {
				if (this.currentDate === '') {
					return true
				} else {
					return false
				}
			},
			...mapGetters('prices', [
				'getPrices', 'getDepartments', 'getRegNumber', 'getLastItems', 'getEditItems'
			]),
			...mapState('prices', [
				'lastOriginalItems'
			]),
			...mapState(['userDepCurrencyName', 'userDepCurrencyCode']),
		},
		async created() {
			await this.loadCategory();
			await this.setCompanyType();
		},

		methods: {
			saveREADY(status) {
				this.pricingStatus = status;
				this.onSave();
			},
			filterPricing() {
				const result1 = this.items.map((item) => {
					return {
						itemId: item.itemId,
						priceEur: item.newPriceEur,
						priceRub: item.newPriceRub,
						priceUzs: item.newPriceUzs,
						priceUsd: item.newPriceUsd,
						incomeEur: item.incomeEur,
						incomeRub: item.incomeRub,
						incomeUzs: item.incomeUzs,
						incomeUsd: item.incomeUsd,
						priceWholesale: item.newPriceWholesale,
						name: item.name,
						artikul: item.artikul,
						barcode: item.barcode,
						color: item.color,
						size: item.size
					};
				});

				let getFilterArray = result1.filter((item) => {
					if (item.priceEur > 0 || item.priceRub > 0 || item.priceUzs > 0 || item.priceUsd > 0 || item.priceWholesale > 0) {
						return item;
					}
				});
				if (getFilterArray.length > 0) {
					this.getPricedItems.push(...getFilterArray);
				}
				return this.getPricedItems;
			},

			setCategoryCode(value) {
				this.allCategory.filter(el => {
					if (el.id === value) {
						this.categoryCode = el.code
					}
				})
			},
			async searchPricing() {
				if (this.selectedDepartment) {
					if (this.selectedDepartment.length > 0) {
						this.count++;
						await this.setFilterToComponent()
						this.loader = true;
						await this.getSearchGeneral(this.attr.link);
						this.items = this.getLastItems;
					} else {
						this.$vs.notify({
							title: "Выберите Подразделение",
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
					}
				} else {
					this.$vs.notify({
						title: "Выберите Подразделение",
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				}

				this.loader = false;
			},
			subSubCategorySelected() {
				if (this.subsubcategory.value !== null) {
					this.sub3category.isDisabled = false
					this.sub3category.value = null
					this.setFilterToComponent()
					this.loadSub3Category(this.subsubcategory.value);
				} else {
					this.sub3category.isDisabled = true
					this.sub3category.value = null

				}

			},
			categorySelected() {
				this.subcategory.isDisabled = true
				this.loadSubCategory(this.filter.category)
				this.setFilterToComponent()
				// if(this.filter.category === 'all'){
				// 	this.subcategory.isDisabled = true
				// 	this.subsubcategory.isDisabled = true
				// }else{
				// 	this.subcategory.isDisabled = false
				// 	this.loadSubCategory(this.filter.category)
				// }
				// this.setFilterToComponent()
			},
			subCategorySelected() {
				this.subsubcategory.isDisabled = false
				if (this.subcategory.value != null) {
					this.loadSubSubCategory(this.subcategory.value)
					this.subsubcategory.value = null;
					this.sub3category.value = null;
					this.sub3category.isDisabled = true;
				} else {
					this.subsubcategory.value = null;
					this.sub3category.value = null;
					this.subsubcategory.isDisabled = true
					this.sub3category.isDisabled = true
				}
			},
			async loadCategory() {
				await ReferencesService.getReferenceChildren(`WAREHOUSE_CATEGORY`).then(response => {
					this.allCategory = response.data;
				})
			},
			loadSubCategory(id) {
				if (id == 'all') {
					this.subcategory.isDisabled = true;
				}
				this.subcategory.isDisabled = true;
				ReferencesService.getSubReferenceChildren(id).then(response => {
					if (response.data) {
						this.subcategory.items = response.data;
					} else {
						this.subcategory.items = null;
					}
					this.subcategory.isDisabled = true;
				})
			},
			loadSubSubCategory(id) {
				if (id == null) {
					this.subsubcategory.isDisabled = true
				}
				this.subsubcategory.isDisabled = true
				ReferencesService.getSubReferenceChildren(id).then(response => {
					this.subsubcategory.items = response.data;
					this.subsubcategory.isDisabled = false

				})
			},
			async loadSub3Category(id) {
				await ReferencesService.getSubReferenceChildren(id).then(response => {
					this.sub3category.items = response.data;
				})
			},
			setCompanyType() {
				this.companyType = TokenService.getDepartmentType()
				if (this.companyType === 'SHOP') {
					this.allCategory.filter(el => {
						if (el.code === 'MAGAZIN') {
							this.filter.category = el.id
						}
					})

					this.loadSubCategory(this.filter.category)
					//this.subcategory.isDisabled = false;
				}

			},
			setFilterToComponent() {
				this.filter.depsId = []
				let depNames = []
				if (Object.keys(this.selectedDepartment).length !== 0) {
					this.selectedDepartment.forEach(item => {
						this.filter.depsId.push(item.id)
						depNames.push(item.name)
					})
					this.disabled = false
					this.attr['departmentId'] = 10;
					this.attr['empty'] = false
					this.attr['depNames'] = depNames
					let str = "departmentIds=" + this.filter.depsId +
						"&catId=" + this.filter.category +
						//						"&start=" + `${ this.filter.start !== '' && this.filter.start !== '__-__-____' ? this.filter.start : null}` +
						//						"&end=" + `${ this.filter.end !== '' && this.filter.end !== '__-__-____' ? this.filter.end : null}` +
						"&barcode=" + `${this.filter.barCode !== '' ? this.filter.barCode : null}` +
						"&name=" + `${this.filter.name !== '' ? this.filter.name : null}` +
						"&artikul=" + `${this.filter.artikul !== '' ? this.filter.artikul : null}` +
						"&subId=" + `${this.subcategory.value !== null ? this.subcategory.value : null}` +
						"&sub2Id=" + `${this.subsubcategory.value !== null ? this.subsubcategory.value : null}` +
						"&sub3Id=" + `${this.sub3category.value !== null ? this.sub3category.value : null}` +
						"&docIdAndDocName=" + `${this.filter.docIdAndDocName !== '' ? this.filter.docIdAndDocName : null}`


					this.attr['link'] = str
//					this.$emit('filter', this.attr);

				} else {
					this.disabled = true
					this.filter.category = 'all'
					this.subcategory.isDisabled = true
					this.subcategory.value = null
					this.subsubcategory.isDisabled = true
					this.subsubcategory.value = null
					this.attr['empty'] = true
					this.attr['departmentId'] = 10;
//					this.$emit('filter', this.attr);
					this.filter.depsId = []
					depNames = []
				}
			},
			async handleNewDepartment(newDep) {
				this.subcategory.isDisabled = false;
				if (this.selectedDepartment.length > 0) {
					this.currency = this.selectedDepartment[0].currencyCode;
					this.depCurrencyName = this.selectedDepartment[0].currencyName;
					if (this.currency == newDep.currencyCode) {
						this.selectedDepartment.push(newDep);
					} else {
						this.$vs.notify({
							title: this.$t('prices.notify'),
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
					}
				} else {
					this.selectedDepartment.push(newDep);
					this.currency = newDep.currencyCode;
					this.depCurrencyName = newDep.currencyName;
				}
				/*let departments = this.selectedDepartment.map((department) => {
					return department.id
				});*/
//				await this.getLastItemList(departments)
//				this.items = this.getLastItems

			},
			async removeDepartment(dep) {
				await this.selectedDepartment.splice(this.selectedDepartment.indexOf(dep), 1);
				let departments = await this.selectedDepartment.map((department) => {
					return department.id;
				});
//				await this.getLastItemList(departments)
// 				this.items = this.getLastItems
				if (this.selectedDepartment.length === 0) {
					this.currency = this.userDepCurrencyCode;
					this.depCurrencyName = this.userDepCurrencyName;
				}
			},
			async closeSidebar() {
				this.selectedDepartment = [];
				this.filter.barCode = null;
				this.filter.name = null;
				this.toggleSearch.filter = false;
				this.toggleForm.form = true;
				this.count = 0;
				this.filter.category = 'all';
				this.subcategory.value = null;
				this.subsubcategory.value = null;
				this.sub3category.value = null;
				this.filter.artikul = '';
				this.filter.docIdAndDocName = '';
				this.tableFilter = '';

				this.regnumber = ''
				this.comment = '';
				this.selectedDepartment = []
				this.isValid = ''
				this.isErrorDepartment = false
				this.ok = false
				this.items = []
				this.currency = this.userDepCurrencyCode;
				this.depCurrencyName = this.userDepCurrencyName;
				this.emptyErrorTable = false
				this.subcategory.isDisabled = true;
				this.subsubcategory.isDisabled = true;
				this.sub3category.isDisabled = true;
				this.getPricedItems = [];
//				this.getDateCurrent()
				await this.$emit('closeSidebar')

			},

			generateRegNumber() {
				this.getRegNumberItem()
				this.regnumber = this.getRegNumber
				this.isValid = true
			},
			async onSave() {
				if (this.regnumber != '') {
					if (this.selectedDepartment.length > 0) {
						if (this.currentDate !== '') {
							const result = this.items.map((item, index) => {
								return {
									itemId: item.itemId,
									priceEur: null,
									priceRub: null,
									priceUzs: null,
									priceUsd: null,
									incomeEur: null,
									incomeRub: null,
									incomeUzs: item.newIncomeUzs,
									incomeUsd: null,
									priceWholesale: null,
									docId: item.docId,
									depId: item.depId
								};
							});
							let getFilteredArray = result.filter((item) => {
								if (this.lastOriginalItems.length !== 0) {
									let foundIndex = this.lastOriginalItems.findIndex(el => {
										return el.itemId == item.itemId;
									})
									if (foundIndex > -1) {
										/*if (item.incomeUzs !== this.lastOriginalItems[foundIndex].incomeUzs || item.priceUzs > 0) {
											if (!item.priceUzs) {
												item.priceUzs = this.lastOriginalItems[foundIndex].priceUzs;
											}
											return item;
										}*/
										/* NEW CODE 24.08.2019 */
										if (item.incomeUzs) {
											if (!item.incomeUzs) {
												item.incomeUzs = this.lastOriginalItems[foundIndex].incomeUzs;
											}
											/*if (!item.priceWholesale) {
												item.priceWholesale = this.lastOriginalItems[foundIndex].priceWholesale;
											}*/
											return item;
										}
									}
								} else if (this.getEditItems.pricingItems.length !== 0) {
									let foundIndex = this.getEditItems.pricingItems.findIndex(el => {
										return el.itemId == item.itemId;
									})
									if (foundIndex > -1) {
										/*if (item.incomeUzs !== this.getEditItems.pricingItems[foundIndex].incomeUzs || item.priceUzs > 0) {
											if (!item.priceUzs) {
												item.priceUzs = this.getEditItems.pricingItems[foundIndex].priceUzs;
											}
											return item;
										}*/
										/* NEW CODE 24.08.2019 */
										if (item.incomeUzs > 0) {
											if (!item.incomeUzs) {
												item.incomeUzs = this.getEditItems.pricingItems[foundIndex].incomeUzs;
											}
											/*if (!item.priceWholesale) {
												item.priceWholesale = this.getEditItems.pricingItems[foundIndex].priceWholesale;
											}*/
											return item;
										}
									}
								}
							});

							if (getFilteredArray.length === 0 && this.getPricedItems.length === 0) {
								this.emptyErrorTable = true
							} else {
								let departments = this.selectedDepartment.map((department) => {
									return department.id
								});
								if (getFilteredArray.length > 0) {
									this.getPricedItems.push(...getFilteredArray);
								}
								let data = {
									id: this.filter.id,
									costNumber: this.regnumber,
									costDate: this.currentDate,
									companiesIds: departments,
									pricingItems: this.count == 1 ? getFilteredArray : this.getPricedItems,
									comment: this.comment,
									pricingStatus: this.pricingStatus,
								}
								if (this.editable) {
									if (this.count == 0) {
										if (getFilteredArray.length > 0) {
											data.pricingItems = getFilteredArray;
										} else {
											data.pricingItems = this.getPricedItems;
										}
									}
									if (this.count == 1) {
										data.pricingItems = this.getPricedItems;
									}

								}
								await this.createPricesList(data);
								this.ok = false
								this.selectedDepartment = [];
								this.filter.barCode = null;
								this.currentDate = '';
								this.filter.id = null;
								this.count = 0;
								this.filter.name = null;
								this.filter.category = 'all';
								this.toggleSearch.filter = false;
								this.toggleForm.form = true;
								this.subcategory.value = null;
								this.subcategory.isDisabled = true;
								this.subsubcategory.isDisabled = true;
								this.sub3category.isDisabled = true;
								this.filter.artikul = '';
								this.tableFilter = '';
								this.subsubcategory.value = null;
								this.regnumber = ''
								this.comment = '';
								this.selectedDepartment = []
								await this.$emit('closeSidebar')

								this.emptyErrorTable = false
								this.regnumber = ''
								this.selectedDepartment = []
								this.items = []
								this.isErrorDepartment = false
								this.isValid = ''
								this.getPricedItems = [];
							}
						}
					} else {
						this.isErrorDepartment = true
					}

				} else {
					this.isValid = false
				}
			},
			focusInput($event, index, inputOrder) {
				let lastIndex = this.getLastItems.length - 1;
				if ($event.keyCode == 37) {
					if (inputOrder == 1 && index == 0) {
						return 1
					}
					if (inputOrder == 1 && index != 0) {
						const refName = (index - 1).toString() + '2'
						this.$refs[refName].$el.focus()
						this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
						return
					}
					if (inputOrder == 2) {
						const refName = index.toString() + (parseInt(inputOrder) - 1).toString()
						this.$refs[refName].$el.focus()
						this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
						return
					}
					const refName = index.toString() + (parseInt(inputOrder) - 1).toString()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
					this.$refs[refName].$el.focus()
				}
				if ($event.keyCode == 39) {
					if (inputOrder == 2 && lastIndex == index) {
						return 1
					}
					if (inputOrder == 2 && lastIndex != index) {
						const refName = (index + 1).toString() + '1'
						this.$refs[refName].$el.focus()
						this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
						return
					}
					const refName = index.toString() + (parseInt(inputOrder) + 1).toString()
					this.$refs[refName].$el.focus()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
				}
				if ($event.keyCode == 38) {
					if (index == 0) {
						return 1
					}
					const refName = (index - 1).toString() + (inputOrder).toString()
					this.$refs[refName].$el.focus()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
				}
				// down
				if ($event.keyCode == 40) {
					if (index == lastIndex) {
						return 1
					}
					const refName = (index + 1).toString() + (inputOrder).toString()
					this.$refs[refName].$el.focus()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
				}

			},
			async OkFunction(refName) {
				await this.changeOk();
				await this.focusRef(refName)
			},
			changeOk() {
				this.ok = true;
				return true
			},
			focusRef(refName) {
				this.$refs[refName].focus();
				this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
				return true;
			},
			...mapActions('prices', [
				'getPricesList', 'createPricesList', 'getDepartmentList', 'getRegNumberItem', 'getLastItemList', 'getSearchGeneral'
			]),
			getDepartmentsLocal() {
				return this.getDepartments
			},
			getPricesLocale() {
//				this.items = this.getLastItems
			}
		},

		components: {
			MaskedInput,
			Multiselect,
			PriceFilter
		},
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
	.emptyErrorTable {
		display: flex;
		justify-content: center;
		padding: 4px 0 7px 0;
	}

	.edit_price {
		cursor: pointer;
	}

	.inputWidth {
		width: 152px;
		height: 16px;
		text-align: center;
	}
	.widthTd {
		text-align: center !important;
	}

	.btn-frame {
		display: flex;
		justify-content: flex-end;
		margin-top: 10px;
	}

	.move {
		height: 20px !important;
		margin-left: 2px;
		width: 70px;
	}

	.top-card {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.isErrorDepartment {
		color: red;
		font-size: 12px;
		margin-left: 20px;
	}

	.redStar {
		color: red;
	}

	.b-table.table > thead > tr > th, .b-table.table > thead > tr > td, .b-table.table > tfoot > tr > th, .b-table.table > tfoot > tr > td {
		text-align: center;
	}

	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 35px;
		z-index: 5;
	}

	.table-wrapper {
		position: relative;
		padding: 5px;
	}
	.emptyDivForPricing {
		width: 70px;
		height: 20px;
	}
</style>
